/**
 * Ask Ethos Fluent UI values: the brand ramp and every theme token that differs
 * between brands. Shared structure: apps/wappbb/frontend/src/theme/fluentTheme.ts
 */

import type { BrandFluent } from "../types";

export const fluent: BrandFluent = {
    brandColors: {
        10: "#061015",
        20: "#0a1d26",
        30: "#122834", // --theme-Darker
        40: "#163445",
        50: "#1b4052", // --theme-Dark
        60: "#234d63",
        70: "#315b6f", // --theme-DarkAlt
        80: "#2d7b9f", // --theme-Primary
        90: "#3d8ab0",
        100: "#5592ae", // --theme-Secondary
        110: "#6da3bd",
        120: "#8ab5cc",
        130: "#add0e2", // --theme-Tertiary
        140: "#cadfe9", // --theme-Light
        150: "#e6f0f5", // --theme-Lighter
        160: "#f5fafd" // --theme-LighterAlt
    },
    fonts: {
        fontFamilyBase: '"IBM Plex Sans", "Helvetica Neue", Arial, sans-serif',
        fontFamilyNumeric: '"IBM Plex Sans", "Helvetica Neue", Arial, sans-serif'
    },
    light: {
        colorNeutralBackground2: "#f0f5f9", // --neutral-LighterAlt
        colorNeutralBackground3: "#d7dde2", // --neutral-Lighter
        colorNeutralBackground4: "#bfc6cb", // --neutral-Light
        colorNeutralForeground1: "#172028", // --neutral-Primary
        colorNeutralForeground2: "#505960", // --neutral-SecondaryAlt
        colorNeutralForeground3: "#a8afb4", // --neutral-QuaternaryAlt
        colorNeutralForegroundDisabled: "#91989e", // --neutral-Quaternary
        colorBrandForeground1: "#2d7b9f", // --theme-Primary
        colorBrandForeground2: "#5592ae", // --theme-Secondary
        colorBrandForegroundLink: "#2d7b9f",
        colorBrandForegroundLinkHover: "#315b6f",
        colorBrandForegroundLinkPressed: "#1b4052",
        colorBrandBackground: "#2d7b9f",
        colorBrandBackgroundHover: "#315b6f",
        colorBrandBackgroundPressed: "#1b4052",
        colorBrandBackgroundSelected: "#5592ae",
        colorSubtleBackgroundHover: "#e6f0f5", // --theme-Lighter
        colorSubtleBackgroundPressed: "#cadfe9", // --theme-Light
        colorSubtleBackgroundSelected: "#e6f0f5",
        colorNeutralStroke1: "#d7dde2", // --neutral-Lighter
        colorNeutralStroke2: "#bfc6cb", // --neutral-Light
        colorBrandStroke1: "#2d7b9f",
        colorBrandStroke2: "#5592ae",
        shadow2: "0px 1px 2px rgba(0, 0, 0, 0.07)",
        shadow4: "0px 2px 4px rgba(0, 0, 0, 0.12)",
        shadow8: "0px 4px 8px rgba(0, 0, 0, 0.12)",
        shadow16: "0px 8px 16px rgba(0, 0, 0, 0.14)",
        shadow28: "0px 14px 28px rgba(0, 0, 0, 0.14)"
    },
    dark: {
        colorNeutralBackground1: "#172028", // --neutral-Primary
        colorNeutralBackground2: "#1b4052", // --theme-Dark
        colorNeutralBackground3: "#29323a", // --neutral-PrimaryAlt
        colorNeutralBackground4: "#3c454c", // --neutral-Secondary
        colorNeutralBackgroundStatic: "#172028",
        colorSubtleBackgroundHover: "#29323a",
        colorSubtleBackgroundPressed: "#172028",
        colorSubtleBackgroundSelected: "#5592ae",
        colorSubtleBackgroundLightAlphaHover: "rgba(41, 50, 58, 0.7)",
        colorSubtleBackgroundLightAlphaPressed: "rgba(23, 32, 40, 0.9)",
        colorNeutralForeground1: "#f0f5f9", // --neutral-LighterAlt
        colorNeutralForeground2: "#d7dde2", // --neutral-Lighter
        colorNeutralForeground3: "#a8afb4", // --neutral-QuaternaryAlt
        colorNeutralForeground4: "#7b8389", // --neutral-TertiaryAlt
        colorNeutralForegroundDisabled: "#505960", // --neutral-SecondaryAlt
        colorBrandForeground1: "#2d7b9f",
        colorBrandForeground2: "#5592ae",
        colorBrandForegroundLink: "#5592ae",
        colorBrandForegroundLinkHover: "#add0e2",
        colorBrandForegroundLinkPressed: "#cadfe9",
        colorBrandBackground: "#2d7b9f",
        colorBrandBackgroundHover: "#315b6f",
        colorBrandBackgroundPressed: "#1b4052",
        colorBrandBackgroundSelected: "#5592ae",
        colorNeutralStroke2: "#3c454c",
        colorNeutralStroke3: "#505960",
        colorBrandStroke1: "#2d7b9f",
        colorBrandStroke2: "#5592ae",
        shadow2: "0px 1px 2px rgba(0, 0, 0, 0.12)",
        shadow4: "0px 2px 4px rgba(0, 0, 0, 0.14)",
        shadow8: "0px 4px 8px rgba(0, 0, 0, 0.14)",
        shadow16: "0px 8px 16px rgba(0, 0, 0, 0.14)",
        shadow28: "-2px -9px 18.1px 0px rgba(0, 0, 0, 0.25)"
    }
};
